import { render, staticRenderFns } from "./GSKArticle.vue?vue&type=template&id=5e47ab10&scoped=true&"
import script from "./GSKArticle.vue?vue&type=script&lang=js&"
export * from "./GSKArticle.vue?vue&type=script&lang=js&"
import style0 from "./GSKArticle.vue?vue&type=style&index=0&id=5e47ab10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47ab10",
  null
  
)

export default component.exports